import React from "react";
import HeroSection5 from '../sectionBlocks/HeroSection3';
import NFTMarketPlace from '../sectionBlocks/NFTMarket';
import Footer from '../sectionBlocks/Footer';
import {Helmet} from "react-helmet";

const Mancaves = ({loading, data, error, localData}) => {
  return (
    <>
      <Helmet>
        <title>Mancaves · PopBeLLy</title>
      </Helmet>
      <HeroSection5/>
      <NFTMarketPlace 
        displayCollectionName = {`dn`} 
        collectionName = {``} 
        displayPagination = {``} 
        displayLink = {`dn`} 
        linkAddress = {``} 
        linkTitle = {``} 
        fetchingCardsRule = {({meta}) => meta.attributes[0].value === "Mancave"} 
        sliceStart = {0}
        loading = {loading} 
        data = {data} 
        error = {error} 
        localData = {localData}
      />
      <Footer/>
    </>
  );
};

export default Mancaves;